import React from 'react';
import PhoneInputWithCountry from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Box, FormHelperText, InputLabel } from '@mui/material';
import { isValidPhoneNumber } from 'libphonenumber-js';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  error,
  helperText,
  label = 'Phone (optional)',
}) => {
  return (
    <Box sx={{ position: 'relative' }}>
      {/* Floating label */}
      <InputLabel
        shrink
        sx={{
          position: 'absolute',
          top: 0,
          left: 10,
          transform: 'translateY(-50%)',
          backgroundColor: 'white',
          px: 0.5,
          fontSize: '0.75rem',
          color: error ? 'error.main' : 'text.secondary',
          zIndex: 1,
        }}
      >
        {label}
      </InputLabel>

      {/* Phone input styled like MUI TextField */}
      <Box
        sx={{
          '& .PhoneInput': {
            width: '100%',
            padding: '16.5px 14px',
            fontSize: '16px',
            border: error ? '1px solid' : '1px solid',
            borderColor: error ? 'error.main' : 'rgba(0, 0, 0, 0.23)',
            borderRadius: '4px',
            fontFamily: 'Roboto, sans-serif',
            backgroundColor: 'transparent',
            '&:hover': {
              borderColor: error ? 'error.main' : 'rgba(0, 0, 0, 0.87)',
            },
            '&:focus-within': {
              borderColor: error ? 'error.main' : 'primary.main',
              borderWidth: '2px',
              padding: '15.5px 13px',
            },
          },
          '& .PhoneInputInput': {
            border: 'none',
            outline: 'none',
            fontSize: '16px',
            fontFamily: 'Roboto, sans-serif',
            backgroundColor: 'transparent',
            width: '100%',
          },
          '& .PhoneInputCountry': {
            marginRight: '8px',
            backgroundColor: 'transparent',
          },
          '& .PhoneInputCountrySelect': {
            backgroundColor: 'transparent',
          },
          '& .PhoneInputCountryIcon': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <PhoneInputWithCountry
          international
          defaultCountry="DO"
          value={value}
          onChange={(val) => onChange(val || '')}
          countryCallingCodeEditable={false}
        />
      </Box>

      <FormHelperText error={error} sx={{ mx: 1.75, mt: 0.5 }}>
        {helperText || ' '}
      </FormHelperText>
    </Box>
  );
};

// Validation helper
export const validatePhoneNumber = (phone: string): string => {
  if (!phone) return 'Phone number is required';
  if (!isValidPhoneNumber(phone)) return 'Invalid phone number';
  return '';
};
